import { NewMeetingInfo } from "@modals";
import Schema, { RuleItem } from 'async-validator';
import moment from 'moment';
import { cloneDeep } from 'lodash';
import { ParticipantInfo } from "@api";

const newMeetingDescriptor = {
	startDateString: {
		type: 'date',
		required: true,
		message: 'Дата проведения обязательна для заполнения',
		validator: (rule, value) => value ? true : false,
	} as RuleItem,
	startAndEndTimes: {
		type: 'array',
		required: true,
		validator: (rule, value) => {
			const errors = [];
			if (!value[0] && !value[1]) {
				errors.push(new Error("Время начала и окончания проведения собрания обязательны для заполнения"));
			}
			if (!value[0]) {
				errors.push(new Error("Время начала проведения собрания обязательно для заполнения"));
			}
			if (!value[1]) {
				errors.push(new Error("Время окончания проведения собрания обязательно для заполнения"));
			}

			if (errors.length) {
				return errors;
			}

			if (!/^[0-2]?[0-9]:[0-5][0-9]$/.test(value[0])) {
				errors.push(new Error("Время начала проведения собрания должно быть в формате ЧЧ:ММ"));
			}
			if (!/^[0-2]?[0-9]:[0-5][0-9]$/.test(value[1])) {
				errors.push(new Error("Время окончания проведения собрания должно быть в формате ЧЧ:ММ"));
			}

			if (errors.length) {
				return errors;
			}

			const startHours = value[0].split(':')[0];
			const startMinutes = value[0].split(':')[1];

			const endHours = value[1].split(':')[0];
			const endMinutes = value[1].split(':')[1];

			if (startHours > 23) {
				errors.push(new Error("Часы начала проведения собрания не должны превышать 23"));
			}

			if (startMinutes > 59) {
				errors.push(new Error("Минуты начала проведения собрания не должны превышать 59"));
			}

			if (endHours > 23) {
				errors.push(new Error("Часы окончания проведения собрания не должны превышать 23"));
			}

			if (endMinutes > 59) {
				errors.push(new Error("Минуты окончания проведения собрания не должны превышать 59"));
			}

			if (errors.length) {
				return errors;
			}
			
			const startDateUtc = moment(value[2])
				.startOf('day')
				.add(startHours, 'hours')
				.add(startMinutes, 'minutes')
				.utc()
				.toDate();

			const endDateUtc = moment(value[2])
				.startOf('day')
				.add(endHours, 'hours')
				.add(endMinutes, 'minutes')
				.utc()
				.toDate();

			if (startDateUtc >= endDateUtc) {
				errors.push(new Error("Время окончания собрания должна быть позже времени начала собрания"));
			}

			return errors;
		}
	} as RuleItem,
	subject: {
		type: 'string',
		required: true,
		message: 'Название обязательно для заполнения',
		validator: (rule, value) => value ? true : false,
	} as RuleItem,

	recordingFileAndIsPlanned: {
		type: 'array',
		required: true,
		validator: (rule, value) => {
			const recordFile = value[0] as File;
			const isPlanned = value[1] as boolean;

			const errors = [];
			if (!isPlanned && !recordFile) {
				errors.push(new Error("Необходимо приложить файл"));
			}

			return errors;
		},
	} as RuleItem,
};

const editMeetingDescriptor = cloneDeep(newMeetingDescriptor) as typeof newMeetingDescriptor;
delete editMeetingDescriptor.recordingFileAndIsPlanned;

const editMeetingRecSettingsDescriptor = cloneDeep(newMeetingDescriptor) as typeof newMeetingDescriptor;
delete editMeetingRecSettingsDescriptor.recordingFileAndIsPlanned;

editMeetingDescriptor['participants'] = {
	type: 'array',
	required: false,
	defaultField: {
		type: 'object',
		required: true,
		message: 'Имя участника обязательно для заполнения',
		validator: (rule, value) => value && value.name ? true : false,
	}
} as RuleItem;


export class ValMeetingInfo extends NewMeetingInfo {
	startDateString: Date;
	startTimeString: string;
	endTimeString: string;
	startAndEndTimes: [string, string, Date];
	participants: ParticipantInfo[];
	recordingFileAndIsPlanned: [File, boolean];
}



export const newMeetingInfoValidator = new Schema(newMeetingDescriptor);
export const editMeetingInfoValidator = new Schema(editMeetingDescriptor);
export const editMeetingRecSettingsValidator = new Schema(editMeetingRecSettingsDescriptor);